export default __webpack_public_path__ + "static/media/2.f93279ad.jpg";